import { render, staticRenderFns } from "./QHqPromotionsDrilldown.vue?vue&type=template&id=4d2b84ec&scoped=true&"
import script from "./QHqPromotionsDrilldown.vue?vue&type=script&lang=js&"
export * from "./QHqPromotionsDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b84ec",
  null
  
)

export default component.exports